import React from 'react';
import PropTypes from 'prop-types';

const ImageDataPoint = ({ url, position, timestamp, cameraName, tooltipId, point_color }) => {
  return (
    <div
      className="image-timeline__data-points--point"
      data-url={url}
      data-timestamp={timestamp}
      style={{ left: `${position}%`, backgroundColor: `${point_color}` }}
      data-tooltip-content={JSON.stringify({ url, timestamp, cameraName })}
      data-tooltip-id={tooltipId}
    />
  );
};

ImageDataPoint.propTypes = {
  url: PropTypes.any.isRequired,
  position: PropTypes.any.isRequired,
  timestamp: PropTypes.any.isRequired,
  cameraName: PropTypes.any.isRequired,
  tooltipId: PropTypes.any.isRequired,
  point_color: PropTypes.string,
};

export default ImageDataPoint;
